import { Link } from "@remix-run/react";

interface SpaceTypeLinkingCardProps {
  title?: string;
  description: string;
  imageSrc: string;
  imageAlt: string;
  linkTo?: string;
}

export default function SpaceTypeLinkingCard({
  title,
  description,
  imageSrc,
  imageAlt,
  linkTo = "#"
}: SpaceTypeLinkingCardProps) {
  return (
    <div className='flex flex-col md:flex-row bg-gray-50 border-gray-50 rounded-lg overflow-hidden -mx-4 md:mx-0'>
      <div className='p-6 flex-1 flex flex-col justify-center'>
        {title && <h3 className='text-lg font-bold mb-4'>{title}</h3>}
        {description && <Link
          to={linkTo}
          target='_blank'
          className='font-semibold text-base hover:text-primary-600 transition-colors'
        >
          → {description}
        </Link>}
      </div>

      <img
        src={imageSrc}
        alt={imageAlt}
        width={720}
        height={405}
        className='w-full md:w-1/2 h-auto object-cover rounded-none md:rounded-r-lg'
      />
    </div>
  )
}